import React from "react";
import ModalNew from "../../../../../components/ui/popup/Modal";
import { PopupHeader } from "../../../../../components/ui/popup/common";
import ESignatureComponent from "../../../../../components/ui/ESignatureComponent";

const Sign8879Modal = ({ isOpen, onClose, onCompleted }) => {
  if (!isOpen) return null;

  return (
    <ModalNew>
      <PopupHeader title="Sign Form 8879" setOpenState={onClose} />
      <div style={{ padding: "20px" }}>
        <ESignatureComponent
          documentType="EFILE_SIGNATURE_AUTHORIZATION"
          onCompleted={onCompleted}
          customSuccessMessage="Form 8879 has been signed and saved successfully."
          successButtonText="Close"
          successButtonAction={onClose}
        />
      </div>
    </ModalNew>
  );
};

export default Sign8879Modal;
